import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57686eb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_project" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "姓名：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "角色：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "状态：", -1))
const _hoisted_11 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Excel导入")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("恢复")
const _hoisted_18 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_19 = { class: "my-header" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加", -1))
const _hoisted_21 = { class: "my-header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Excel导入", -1))

import { CirclePlus,Search } from '@element-plus/icons-vue';
	import { reactive,ref,onMounted,nextTick } from 'vue';
	import AddUser from '@/components/AddUser.vue';
	import { requestUserList,requestBaseDel,requestReset } from '@/api/api';
	import { ElMessage } from 'element-plus';
	import Excel from '@/components/Excel'
	
export default /*#__PURE__*/_defineComponent({
  name: 'User',
  setup(__props) {

	const loading = ref(false)
	const tableData = ref([])
	const pageIndex = ref(1)
	const pageSize = ref(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		name:'',
		rolelist:'',
		status:1
	})//搜索
	const addShow = ref(false)
	const userShow = ref(false)
	const exceladdShow = ref<boolean>(false)
	const excelShow= ref<boolean>(false)
	const uuid = ref("")
	onMounted(()=>{
		getUserList();
	})
	const getUserList = () =>{
		loading.value = true
		requestUserList({
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			name:search.value.name,
			rolelist:search.value.rolelist,
			status:search.value.status
		}).then((res:any)=>{
			tableData.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	//恢复
	const hf = (row: any) => {
		requestReset({
			type:"user",
			uuid:row.cell.uuid
		}).then((res: any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "恢复成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					pageIndex.value = 1
					getUserList();
				},500)
			}
		})
	}
	// 移除
	const del = (row: any) =>{
		requestBaseDel({
			type:"user",
			uuid:row.cell.uuid
		}).then((res: any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "移除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					pageIndex.value = 1
					getUserList();
				},500)
			}
		})
	}
	//提交成功后
	const cancel = (val: any) => {
		addShow.value = false
		if(val){
			getUserList();
		}
	}
	//详情
	const details = (row: any) =>{
		uuid.value = row.cell.uuid
		addShow.value = true
		sx();
	}
	const sx = () =>{
		userShow.value = false
		nextTick(()=>{
			userShow.value = true
		})
	}
	//添加
	const add = () =>{
		uuid.value = ""
		sx();
		addShow.value = true
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getUserList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getUserList();
	}
	const searchList = () =>{
		pageIndex.value = 1
		getUserList();
	}

	
	const excelsx = () =>{
		excelShow.value = false
		nextTick(()=>{
			excelShow.value = true
		})
	}
	const excelcancel = () => {
		exceladdShow.value = false
		getUserList();
	}
	const exceladd = ()=>{
		excelsx();
		exceladdShow.value = true
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.name) = $event)),
              style: {width:'150px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_select, {
              modelValue: search.value.rolelist,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.rolelist) = $event)),
              style: {"width":"150px"},
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "",
                  value: ""
                }),
                _createVNode(_component_el_option, {
                  label: "管理员",
                  value: "管理员"
                }),
                _createVNode(_component_el_option, {
                  label: "成员",
                  value: "成员"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_select, {
              modelValue: search.value.status,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.status) = $event)),
              style: {"width":"150px"},
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "正常",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "删除",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (searchList())),
            size: "small",
            icon: _unref(Search),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (add())),
            size: "small",
            icon: _unref(CirclePlus),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (exceladd())),
            size: "small",
            icon: _unref(CirclePlus),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["icon"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      "empty-text": "暂无数据",
      data: tableData.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.code",
          label: "编号",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.user",
          label: "用户名",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.name",
          label: "姓名",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.rolelist",
          label: "角色",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          label: "任务启动",
          width: "120",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.cell.taskstartperm === '1' ? 'success' : 'danger',
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.cell.taskstartperm === '1' ? '有权限' : '无权限'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: ($event: any) => (details(scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (scope.row.cell.user!='admin'&&scope.row.cell.status==1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  type: "danger",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (del(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (scope.row.cell.user!='admin'&&scope.row.cell.status==3)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "warning",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (hf(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "添加",
      modelValue: addShow.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (addShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (userShow.value)
          ? (_openBlock(), _createBlock(AddUser, {
              key: 0,
              onCancel: cancel,
              uuid: uuid.value
            }, null, 8, ["uuid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "Excel导入",
      modelValue: exceladdShow.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((exceladdShow).value = $event)),
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (exceladdShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (excelShow.value)
          ? (_openBlock(), _createBlock(_unref(Excel), {
              key: 0,
              onCancel: _cache[12] || (_cache[12] = ($event: any) => (excelcancel())),
              id: "用户导入"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})